import { useEffect } from "react";
import { useLocation, useRoute } from "wouter";
import { getStaffPortalReadiness } from "@/lib/staff-portal-readiness";

// The staff path no longer asks for a role or area. The assistant runs as the
// signed-in user and resolves their role from the login session server-side, so
// this route simply forwards straight into the full-screen chat. It is kept as a
// thin redirect so existing /portal/:apiKey/staff links and bookmarks keep
// working. The readiness check stays in lock-step with the gateway.
export default function PortalRoleSelect() {
  const [, setLocation] = useLocation();
  const [, params] = useRoute("/portal/:apiKey/staff");
  const apiKey = params?.apiKey || "";

  useEffect(() => {
    if (!apiKey) return;
    let cancelled = false;
    fetch(`/api/v1/chatbots/${apiKey}/config`)
      .then((r) => (r.ok ? r.json() : null))
      .catch(() => null)
      .then((cfg) => {
        if (cancelled) return;
        if (getStaffPortalReadiness(cfg)?.isReady === true)
          setLocation(`/chat/${apiKey}?from=portal`);
        else
          setLocation(`/portal/${apiKey}`);
      });
    return () => {
      cancelled = true;
    };
  }, [apiKey]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-background to-muted/40">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" data-testid="loading-staff-redirect" />
    </div>
  );
}
